import { useCallback } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { IconClose } from 'src/assets/icons/IconClose';
import { Loader } from 'src/components/Loader';
import { ResourceThumbnailTooltip } from 'src/components/ResourceThumbnailTooltip';
import { isResourceUploadId } from 'src/data/performance';
import { PROMPT_ACTION } from 'src/data/prompt';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  resource: PropTypes.shape().isRequired,
  index: PropTypes.number,
  onAction: PropTypes.func.isRequired,
};

const defaultProps = {
  className: '',
  index: 0,
};

export const AttachmentImage = ({ className, resource, index, onAction }) => {
  const styles = useStyles();

  const handleTooltipClick = useCallback(() => {
    onAction(PROMPT_ACTION.openResourceInNewTab, { resource });
  }, [resource, onAction]);

  const handleRemoveClick = useCallback(() => {
    onAction(PROMPT_ACTION.removeFileResource, {
      id: resource.id,
      contentType: resource.contentType,
      label: resource.label || resource.name,
      index,
    });
  }, [onAction, resource, index]);

  return isResourceUploadId(resource.id) ? (
    <div
      className={cx(styles.root, className, {
        [styles.loading]: true,
      })}
    >
      <Loader size={16} />
    </div>
  ) : (
    <ResourceThumbnailTooltip
      thumbnailUrl={resource?.file?.thumbnailUrl}
      label={resource?.label}
      onClick={handleTooltipClick}
      placement="bottom-start"
    >
      <div
        className={cx(styles.root, className)}
        style={{
          backgroundImage: 'url("' + resource?.file?.thumbnailUrl + '")',
        }}
      >
        <IconClose
          className={styles.buttonRemove}
          onClick={handleRemoveClick}
        />
      </div>
    </ResourceThumbnailTooltip>
  );
};

AttachmentImage.propTypes = propTypes;
AttachmentImage.defaultProps = defaultProps;
